import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export const isCommercialFeatureEnabled = ({
  accountId,
  feature,
  isFeatureEnabled,
}) => {
  if (!isFeatureEnabled(accountId, FEATURE_FLAGS.BOTZ_CRM_CORE)) return false;
  if (
    feature === FEATURE_FLAGS.BOTZ_CRM_INTELLIGENCE &&
    !isFeatureEnabled(accountId, FEATURE_FLAGS.BOTZ_CRM_REPORTS)
  ) {
    return false;
  }

  return isFeatureEnabled(accountId, feature);
};
